import TurfBuffer from '@turf/buffer';

class LayerCable {



	constructor(du, scenario, tc) {

		this.scenario = scenario;
		this.map = du.map;
		this.du = du;
		this.tc = tc;
		this.currentCable = false;
		this.currentCableIdx = false;


	}
	refreshData(){

		var lines = structuredClone(this.scenario.powerlines);
		this.data = {
			"type":"FeatureCollection",
			"features":[]
		};
		const buffers = [];
		this.data.features = lines.map((f)=>{
			f.type = 'Feature';
			f.properties = {...f.properties};
			f.properties.width = f.width ? f.width : LayerCable.defaultWidth;
			f.properties.color = f.color ? f.color : LayerCable.defaultColor;
			f.properties.invisible = f.invisible ?? f?.properties?.invisible;

			if(f.properties && f.properties.tempid)
				f.id = f.properties.tempid;
			else
				f.id = f.powerlineid;

			//test if cable was deleted
			if(f.geometry && f.geometry.coordinates && f.geometry.coordinates.length){
				var buff = TurfBuffer(f, f.properties.width/2, { units: 'meters' });
				buff.bufferid = f.id;
				buff.id = 100000000+f.id;
				buff.properties.powerlineid = f.id;
				buffers.push(buff);
			}
			return f;
		});

		this.data.features.push(...buffers);
	}



//	placeCables(){
//		this.refreshData();
//
//		var self = this;
//
//
//		const buffers = [];
//
//		if(this.map.getLayer('pl_layer')){
//			this.map.removeLayer('pl_layer');
//			this.map.removeLayer('pl_layer_buff');
//			this.map.removeSource('pl_source');
//		}
//
//
//		if(!this.map.getSource('pl_source'))
//			this.map.addSource('pl_source', {
//				'type': 'geojson',
//				'data': this.data
//			});
//
//		// Add a new layer to visualize the polygon.
//		if(!this.map.getLayer('pl_layer')){
//			this.map.addLayer({
//				'id': 'pl_layer_buff',
//				'type': 'fill',
//				'source': 'pl_source', // reference the data source
//				'layout': {
//					'visibility' : this.map.layerStatus['pl_layer'] ? 'visible' : 'none'
//				},
//				'paint': {
//					'fill-color': ["get", "color"],
//					'fill-opacity': ['case',
//						['boolean', ['feature-state', 'invisible'], false],0,
//						['boolean', ['feature-state', 'hover'], false],1,
//						['boolean', ['feature-state', 'selected'], false],.3,
//						.3
//					]
//				},
//				'filter': ['==', '$type', 'Polygon']
//			});
//			this.map.addLayer({
//				'id': 'pl_layer',
//				'type': 'line',
//				'source': 'pl_source', // reference the data source
//				'layout': {
//					'visibility' : this.map.layerStatus['pl_layer'] ? 'visible' : 'none'
//				},
//				'paint': {
//					'line-color': ["get", "color"],
//					'line-width': 3,
//					'line-opacity': ['case',
//						['boolean', ['feature-state', 'invisible'], false],0,
//						1
//					]
//				},
//				'filter': ['==', '$type', 'LineString']
//			});
//
//		}
//	}


	json(){
		this.refreshData();
		const l = {
			"source" : {
				'type': 'geojson',
				'data': this.data,
				'id': LayerCable.sourceId,
			},
			'images': [
				{
					'src': '/images/line.png',
					'name': 'powerline_pattern'
				},
			],
			'layer' : [

				{
					'id': LayerCable.bufferId,
					'type': 'fill',
					'source': LayerCable.sourceId,
					'paint': {
						'fill-color': ["get", "color"],
						'fill-opacity': ['case',
							['boolean', ['get', 'invisible'], false],0,
							['boolean', ['feature-state', 'invisible'], false],0,
							['boolean', ['feature-state', 'hover'], false],1,
							['boolean', ['feature-state', 'selected'], false],.3,
							.3
						]
					},
					'filter': ['==', '$type', 'Polygon']
				},
				{
					'id': LayerCable.layerId,
					'type': 'line',
					'source': LayerCable.sourceId,
					'paint': {
						'line-color': '#ff0000',
						'line-width': 15,
						'line-opacity': ['case',
							['boolean', ['get', 'invisible'], false],0,
							['boolean', ['feature-state', 'invisible'], false],0,
							1
						],
						'line-pattern':'powerline_pattern'
					},
					'filter': ['==', '$type', 'LineString']
				}
			]
		};

		return l;
	}
}

LayerCable.layerId			= 'pl_layer';
LayerCable.bufferId			= 'pl_layer_buff';
LayerCable.handlesId		= 'cable_handle_circles';
LayerCable.sourceId			= 'pl_source';
LayerCable.defaultWidth		= 6;
LayerCable.defaultColor		= "#000000";
LayerCable.layers			= [
	{id: LayerCable.layerId },
	{id: LayerCable.bufferId }
]
LayerCable.generateBufferId = function(originalId){
	return 100000000+parseInt(originalId);
};


export default LayerCable;
